import React from 'react'
import ContactSection from '../component/Contact/Contact'
import Layout from '../component/Layout/Layout'
import ContentHeader from './ContentHeader'

export default function Contact() {
  return (
    <div id="CONTACT">
    <Layout >
        <ContentHeader name={'Get In Touch'} />
        <ContactSection />
    </Layout>
    </div>
  )
}
